<template>
  <svg
    version="1.1"
    :id="iconName"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 18 17"
    fill="none"
    style="enable-background:new 0 0 18 17;"
    :class="iconName"
    xml:space="preserve"
    :width="width"
    :height="height"
  >
    <title :id="iconName" lang="en">{{ iconName }} icon</title>
    <g id="icon_logout">
      <path
        id="Ellipse 530"
        d="M12.876 1C15.3354 2.36473 17 4.98797 17 8C17 12.4183 13.4183 16 9 16C4.58172 16 1 12.4183 1 8C1 5.03887 2.60879 2.4535 5 1.07026"
        stroke="#F83030"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        id="Vector 57"
        d="M9.5 1C9.5 0.723858 9.27614 0.5 9 0.5C8.72386 0.5 8.5 0.723858 8.5 1H9.5ZM8.5 9.5C8.5 9.77614 8.72386 10 9 10C9.27614 10 9.5 9.77614 9.5 9.5H8.5ZM8.5 1V9.5H9.5V1H8.5Z"
        fill="#F83030"
      />
    </g>
  </svg>
</template>
<style scoped>
.icon-logout {
  stroke: currentColor;
  height: 24px;
  width: 24px;
  border-radius: initial;
  display: block;
}
</style>
<script>
export default {
  props: {
    iconName: {
      type: String,
      default: "icon-logout"
    },
    width: {
      type: [Number, String],
      default: 12
    },
    height: {
      type: [Number, String],
      default: 12
    },
    iconColor: {
      type: String,
      default: "currentColor"
    }
  }
};
</script>